// import { useState } from 'react';

// interface ExpertModalProps {
//   onClose: () => void;
// }

// export default function ExpertModal({ onClose }: ExpertModalProps) {
//   const [submitted, setSubmitted] = useState(false);

//   return (
//     <div
//       className="fixed inset-0 z-[100] flex items-end md:items-center justify-center p-4"
//       style={{ background: 'rgba(0,0,0,0.85)' }}
//       onClick={(e) => e.target === e.currentTarget && onClose()}
//     >
//       <div
//         className="w-full max-w-md rounded-2xl overflow-hidden"
//         style={{ background: 'var(--white)' }}
//       >
//         {/* Header */}
//         <div
//           className="px-6 py-5 flex items-center justify-between"
//           style={{ background: 'var(--navy)' }}
//         >
//           <div>
//             <h2
//               className="text-[17px] font-extrabold text-white"
//               style={{ fontFamily: 'Manrope, sans-serif' }}
//             >
//               Speak With A Travel Expert
//             </h2>
//             <p className="text-white/50 text-[12px] mt-0.5">We'll call you back within 30 minutes</p>
//           </div>
//           <button onClick={onClose} className="text-white/60 hover:text-white text-2xl leading-none">
//             ×
//           </button>
//         </div>

//         {/* Quick contact options */}
//         <div
//           className="grid grid-cols-3 divide-x"
//           style={{ borderBottom: '1px solid var(--border)' }}
//         >
//           {[
//             { icon: '📱', label: 'WhatsApp', value: '+91 98765 43210', color: '#25D366' },
//             { icon: '📞', label: 'Call Now', value: '+91 98765 43210', color: 'var(--royal)' },
//             { icon: '✉', label: 'Email', value: 'hello@aerova.in', color: 'var(--gold)' },
//           ].map((c) => (
//             <button
//               key={c.label}
//               className="flex flex-col items-center py-4 px-3 text-center hover:bg-gray-50 transition-colors"
//               style={{ borderRight: '1px solid var(--border)' }}
//             >
//               <span className="text-xl mb-1">{c.icon}</span>
//               <p className="text-[11px] font-bold" style={{ fontFamily: 'Manrope, sans-serif', color: c.color }}>
//                 {c.label}
//               </p>
//               <p className="text-[10px]" style={{ color: 'var(--text-muted)' }}>{c.value.slice(0, 14)}</p>
//             </button>
//           ))}
//         </div>

//         {/* Callback form */}
//         {!submitted ? (
//           <div className="p-6">
//             <p className="text-[13px] font-semibold mb-4" style={{ color: 'var(--text-secondary)', fontFamily: 'Manrope, sans-serif' }}>
//               Or, request a callback at your preferred time:
//             </p>
//             <div className="space-y-3">
//               {[
//                 { label: 'Your Name', placeholder: 'Sunita Reddy', type: 'text' },
//                 { label: 'Mobile Number', placeholder: '+91 98765 43210', type: 'tel' },
//                 { label: 'Email', placeholder: 'sunita@example.com', type: 'email' },
//               ].map((f) => (
//                 <div key={f.label}>
//                   <label className="block text-[11px] font-bold uppercase tracking-wider mb-1" style={{ color: 'var(--text-muted)', fontFamily: 'Manrope, sans-serif' }}>
//                     {f.label}
//                   </label>
//                   <input
//                     type={f.type}
//                     placeholder={f.placeholder}
//                     className="w-full px-3 py-2.5 rounded-lg text-[13px] outline-none"
//                     style={{ border: '1.5px solid var(--border)', color: 'var(--navy)' }}
//                   />
//                 </div>
//               ))}
//               <div>
//                 <label className="block text-[11px] font-bold uppercase tracking-wider mb-1" style={{ color: 'var(--text-muted)', fontFamily: 'Manrope, sans-serif' }}>
//                   Service
//                 </label>
//                 <select className="w-full px-3 py-2.5 rounded-lg text-[13px] outline-none" style={{ border: '1.5px solid var(--border)', color: 'var(--navy)' }}>
//                   <option>General Enquiry</option>
//                   <option>Flight Tickets</option>
//                   <option>Tours / Holidays</option>
//                   <option>Visa Consultancy</option>
//                   <option>Corporate Travel</option>
//                   <option>Hotels</option>
//                 </select>
//               </div>
//               <div>
//                 <label className="block text-[11px] font-bold uppercase tracking-wider mb-1" style={{ color: 'var(--text-muted)', fontFamily: 'Manrope, sans-serif' }}>
//                   Preferred Call Time
//                 </label>
//                 <select className="w-full px-3 py-2.5 rounded-lg text-[13px] outline-none" style={{ border: '1.5px solid var(--border)', color: 'var(--navy)' }}>
//                   <option>As soon as possible</option>
//                   <option>Morning (9 AM – 12 PM)</option>
//                   <option>Afternoon (12 PM – 4 PM)</option>
//                   <option>Evening (4 PM – 7 PM)</option>
//                 </select>
//               </div>
//               <button
//                 onClick={() => setSubmitted(true)}
//                 className="w-full py-3 rounded-xl text-[14px] font-bold btn-gold mt-2"
//               >
//                 Request a Call
//               </button>
//             </div>
//           </div>
//         ) : (
//           <div className="p-8 text-center">
//             <div
//               className="w-12 h-12 rounded-2xl flex items-center justify-center text-xl mx-auto mb-4"
//               style={{ background: 'rgba(22,134,91,0.1)' }}
//             >
//               ✓
//             </div>
//             <p className="font-extrabold text-[17px] mb-2" style={{ fontFamily: 'Manrope, sans-serif', color: 'var(--navy)' }}>
//               Request Received!
//             </p>
//             <p className="text-[13px] mb-5" style={{ color: 'var(--text-secondary)' }}>
//               A travel expert will call you back within 30 minutes during business hours.
//             </p>
//             <button onClick={onClose} className="px-6 py-2.5 rounded-xl text-[13px] font-bold btn-gold">
//               Done
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }














import React, { useEffect, useState } from 'react';

export default function ExpertModal({ onClose }) {
    const [submitted, setSubmitted] = useState(false);
    const [isDesktop, setIsDesktop] = useState(
        typeof window !== 'undefined' ? window.innerWidth >= 768 : true
    );

    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(window.innerWidth >= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                zIndex: 100,
                display: 'flex',
                alignItems: isDesktop ? 'center' : 'flex-end',
                justifyContent: 'center',
                padding: '16px',
                background: 'rgba(0,0,0,0.85)',
                overflowY: 'auto', // 1. Allow the overlay backdrop to scroll if needed
            }}
            onClick={(e) => e.target === e.currentTarget && onClose()}
        >
            <div
                style={{
                    width: '100%',
                    maxWidth: '448px',
                    maxHeight: '90vh', // 2. Limit modal height to viewport
                    display: 'flex',
                    flexDirection: 'column', // 3. Enable flex column structure for internal scrolling
                    borderRadius: '16px',
                    overflow: 'hidden',
                    background: 'var(--white, #ffffff)',
                    fontFamily: 'Manrope, sans-serif',
                }}
            >
                {/* Header */}
                <div
                    style={{
                        padding: '20px 24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        background: 'var(--navy, #0a192f)',
                        flexShrink: 0, // Prevent header from shrinking
                    }}
                >
                    <div>
                        <h2
                            style={{
                                fontSize: '17px',
                                fontWeight: 800,
                                color: '#ffffff',
                                margin: 0,
                                fontFamily: 'Manrope, sans-serif',
                            }}
                        >
                            Speak With A Travel Expert
                        </h2>
                        <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px', margin: '2px 0 0 0' }}>
                            We'll call you back within 30 minutes
                        </p>
                    </div>
                    <button
                        onClick={onClose}
                        style={{
                            color: 'rgba(255,255,255,0.6)',
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            fontSize: '24px',
                            lineHeight: 1,
                            padding: 0,
                        }}
                    >
                        ×
                    </button>
                </div>

                {/* Scrollable Body Wrapper */}
                <div style={{ overflowY: 'auto', flex: 1 }}>
                    {/* Quick contact options */}
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                            borderBottom: '1px solid var(--border, #e2e8f0)',
                        }}
                    >
                        {[
                            { icon: '📱', label: 'WhatsApp', value: '+91 98765 43210', color: '#25D366' },
                            { icon: '📞', label: 'Call Now', value: '+91 98765 43210', color: 'var(--royal, #1d4ed8)' },
                            { icon: '✉', label: 'Email', value: 'hello@aerova.in', color: 'var(--gold, #f47b20)' },
                        ].map((c, index, arr) => (
                            <button
                                key={c.label}
                                type="button"
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    padding: '16px 12px',
                                    textAlign: 'center',
                                    background: 'transparent',
                                    border: 'none',
                                    cursor: 'pointer',
                                    borderRight: index < arr.length - 1 ? '1px solid var(--border, #e2e8f0)' : 'none',
                                    transition: 'background-color 0.2s',
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f8fafc')}
                                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                            >
                                <span style={{ fontSize: '20px', marginBottom: '4px' }}>{c.icon}</span>
                                <p
                                    style={{
                                        fontSize: '11px',
                                        fontWeight: 700,
                                        margin: '0 0 2px 0',
                                        fontFamily: 'Manrope, sans-serif',
                                        color: c.color,
                                    }}
                                >
                                    {c.label}
                                </p>
                                <p style={{ fontSize: '10px', margin: 0, color: 'var(--text-muted, #64748b)' }}>
                                    {c.value.slice(0, 14)}
                                </p>
                            </button>
                        ))}
                    </div>

                    {/* Callback form */}
                    {!submitted ? (
                        <div style={{ padding: '24px' }}>
                            <p
                                style={{
                                    fontSize: '13px',
                                    fontWeight: 600,
                                    marginBottom: '16px',
                                    marginTop: 0,
                                    color: 'var(--text-secondary, #334155)',
                                    fontFamily: 'Manrope, sans-serif',
                                }}
                            >
                                Or, request a callback at your preferred time:
                            </p>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                {[
                                    { label: 'Your Name', placeholder: 'Sunita Reddy', type: 'text' },
                                    { label: 'Mobile Number', placeholder: '+91 98765 43210', type: 'tel' },
                                    { label: 'Email', placeholder: 'sunita@example.com', type: 'email' },
                                ].map((f) => (
                                    <div key={f.label}>
                                        <label
                                            style={{
                                                display: 'block',
                                                fontSize: '11px',
                                                fontWeight: 700,
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.05em',
                                                marginBottom: '4px',
                                                color: 'var(--text-muted, #64748b)',
                                                fontFamily: 'Manrope, sans-serif',
                                            }}
                                        >
                                            {f.label}
                                        </label>
                                        <input
                                            type={f.type}
                                            placeholder={f.placeholder}
                                            style={{
                                                width: '100%',
                                                padding: '10px 12px',
                                                borderRadius: '8px',
                                                fontSize: '13px',
                                                outline: 'none',
                                                border: '1.5px solid var(--border, #e2e8f0)',
                                                color: 'var(--navy, #0a192f)',
                                                boxSizing: 'border-box',
                                            }}
                                        />
                                    </div>
                                ))}
                                <div>
                                    <label
                                        style={{
                                            display: 'block',
                                            fontSize: '11px',
                                            fontWeight: 700,
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.05em',
                                            marginBottom: '4px',
                                            color: 'var(--text-muted, #64748b)',
                                            fontFamily: 'Manrope, sans-serif',
                                        }}
                                    >
                                        Service
                                    </label>
                                    <select
                                        style={{
                                            width: '100%',
                                            padding: '10px 12px',
                                            borderRadius: '8px',
                                            fontSize: '13px',
                                            outline: 'none',
                                            border: '1.5px solid var(--border, #e2e8f0)',
                                            color: 'var(--navy, #0a192f)',
                                            background: '#ffffff',
                                            boxSizing: 'border-box',
                                        }}
                                    >
                                        <option>General Enquiry</option>
                                        <option>Flight Tickets</option>
                                        <option>Tours / Holidays</option>
                                        <option>Visa Consultancy</option>
                                        <option>Corporate Travel</option>
                                        <option>Hotels</option>
                                    </select>
                                </div>
                                <div>
                                    <label
                                        style={{
                                            display: 'block',
                                            fontSize: '11px',
                                            fontWeight: 700,
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.05em',
                                            marginBottom: '4px',
                                            color: 'var(--text-muted, #64748b)',
                                            fontFamily: 'Manrope, sans-serif',
                                        }}
                                    >
                                        Preferred Call Time
                                    </label>
                                    <select
                                        style={{
                                            width: '100%',
                                            padding: '10px 12px',
                                            borderRadius: '8px',
                                            fontSize: '13px',
                                            outline: 'none',
                                            border: '1.5px solid var(--border, #e2e8f0)',
                                            color: 'var(--navy, #0a192f)',
                                            background: '#ffffff',
                                            boxSizing: 'border-box',
                                        }}
                                    >
                                        <option>As soon as possible</option>
                                        <option>Morning (9 AM – 12 PM)</option>
                                        <option>Afternoon (12 PM – 4 PM)</option>
                                        <option>Evening (4 PM – 7 PM)</option>
                                    </select>
                                </div>
                                <button
                                    type="button"
                                    onClick={() => setSubmitted(true)}
                                    style={{
                                        width: '100%',
                                        padding: '12px',
                                        borderRadius: '12px',
                                        fontSize: '14px',
                                        fontWeight: 700,
                                        marginTop: '8px',
                                        border: 'none',
                                        cursor: 'pointer',
                                        background: 'var(--gold, #f47b20)',
                                        color: 'var(--navy, #0a192f)',
                                        fontFamily: 'Manrope, sans-serif',
                                    }}
                                >
                                    Request a Call
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div style={{ padding: '32px 24px', textAlign: 'center' }}>
                            <div
                                style={{
                                    width: '48px',
                                    height: '48px',
                                    borderRadius: '16px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '20px',
                                    margin: '0 auto 16px auto',
                                    background: 'rgba(22,134,91,0.1)',
                                    color: '#16865b',
                                }}
                            >
                                ✓
                            </div>
                            <p
                                style={{
                                    fontWeight: 800,
                                    fontSize: '17px',
                                    marginBottom: '8px',
                                    marginTop: 0,
                                    fontFamily: 'Manrope, sans-serif',
                                    color: 'var(--navy, #0a192f)',
                                }}
                            >
                                Request Received!
                            </p>
                            <p
                                style={{
                                    fontSize: '13px',
                                    marginBottom: '20px',
                                    marginTop: 0,
                                    color: 'var(--text-secondary, #334155)',
                                }}
                            >
                                A travel expert will call you back within 30 minutes during business hours.
                            </p>
                            <button
                                type="button"
                                onClick={onClose}
                                style={{
                                    padding: '10px 24px',
                                    borderRadius: '12px',
                                    fontSize: '13px',
                                    fontWeight: 700,
                                    border: 'none',
                                    cursor: 'pointer',
                                    background: 'var(--gold, #f47b20)',
                                    color: 'var(--navy, #0a192f)',
                                    fontFamily: 'Manrope, sans-serif',
                                }}
                            >
                                Done
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}